import * as React from 'react';
import { NoSsr } from '@cian/react-utils';

import { FeedbackFormContainer } from './FeedbackForm';
import { useApplicationContext } from '../../utils/applicationContext';

export const FeedbackFormConditionalContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const techProblemsBannerEnabled = config.get('feedbackForm.techProblemsBanner.enabled');

  if (techProblemsBannerEnabled) {
    return null;
  }

  return (
    <NoSsr>
      <FeedbackFormContainer />
    </NoSsr>
  );
};
